import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.scss']
})
export class AnnouncementsComponent implements OnInit {
  protected referalCode:string=this.getCookie('referenceBhavani');
  public hidden: boolean = false;
  public announcements = {
    text: this.getAnnouncementText(),
    link: this.getAnnouncementLink(),
    link_text: this.getAnnouncementLinkText(),
  };
  constructor(@Inject(DOCUMENT) private document:Document,
    @Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit(): void {
  }

  getAnnouncementText() {
    return $localize.locale === 'en' ? 'Te encuentras navegando en nuestro sitio en Inglés.' : 'You are browsing our site in Spanish.';
  }

  getAnnouncementLink() {
    if (!isPlatformBrowser(this.platformId)) return '';
    if (!this.referalCode)return ($localize.locale === 'es' ? 'https://bhavani.app/en/': 'https://bhavani.app/es/')+location.pathname.split('/').slice(2).join('/');
    return $localize.locale === 'es' ? 'https://bhavani.app/en/r/' + this.referalCode : 'https://bhavani.app/es/r/' + this.referalCode;
  }

  getAnnouncementLinkText() {
    if (!isPlatformBrowser(this.platformId)) return '';
    return $localize.locale === 'en' ? 'Ir a la versión en Español' : 'Go to the English version';
  }

  private getCookie(name: string) {
    if (!isPlatformBrowser(this.platformId)) return '';
    let ca: Array<string> = this.document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }

  public hiddenAnnouncement() {
    this.hidden = true;
  }

}
